"use client"

import { Icon, IconButton, useColorMode } from "@chakra-ui/react"
import { MoonIcon, SunIcon } from "@heroicons/react/outline"

import type React from "react"

const DarkModeToggleButton: React.FC = () => {
    const { colorMode, toggleColorMode } = useColorMode()
    const handleClick = () => toggleColorMode()

    return (
        <IconButton
            aria-label='Toggle Dark Mode'
            variant='ghost'
            color='dark'
            _dark={{
                color: "white"
            }}
            _hover={{ color: "green.500", _dark: { color: "gray.200" } }}
            aspectRatio='1/1'
            icon={
                <Icon as={colorMode === "dark" ? MoonIcon : SunIcon} boxSize={{ base: 5, lg: 6 }} />
            }
            onClick={handleClick}
        />
    )
}

export default DarkModeToggleButton
